import type { CityWeather } from "./agendaWeatherTypes";

export type WeatherRowText = {
  /** Row title in the sticky name column. */
  title: string;
  /** Min–max temperature under the title, when available. */
  range: string | null;
  /** Message shown across the hour columns when there is nothing per hour. */
  notice: string | null;
};

export function resolveWeatherRowText(params: {
  cityWeather: CityWeather | null;
  loading: boolean;
  failed: boolean;
  isPastDate: boolean;
}): WeatherRowText {
  const { cityWeather, loading, failed, isPastDate } = params;
  const title = isPastDate || cityWeather?.observed ? "Clima registrado" : "Previsão do tempo";

  if (loading) {
    return { title, range: null, notice: isPastDate ? "Carregando clima..." : "Carregando previsão..." };
  }

  if (failed || !cityWeather || !cityWeather.available || !cityWeather.summary) {
    let notice = "Previsão indisponível no momento";
    if (isPastDate) {
      notice = "Clima indisponível para dias anteriores";
    } else if (cityWeather?.unavailableReason === "outside_forecast_window") {
      notice = "Previsão disponível apenas para os próximos 3 dias";
    }
    return { title, range: null, notice };
  }

  const { minTemperatureC, maxTemperatureC } = cityWeather.summary;
  return { title, range: `${minTemperatureC}°–${maxTemperatureC}°`, notice: null };
}
